import type { INativeLanguageContent } from './types';

const loadNativeEn = (): Promise<Record<string, INativeLanguageContent>> =>
  import('./en').then((m) => m.nativeContentEn);

const nativeContentLoaders: Record<string, () => Promise<Record<string, INativeLanguageContent>>> =
  {
    ar: () => import('./ar').then((m) => m.nativeContentAr),
    bn: () => import('./bn').then((m) => m.nativeContentBn),
    de: () => import('./de').then((m) => m.nativeContentDe),
    en: loadNativeEn,
    es: () => import('./es').then((m) => m.nativeContentEs),
    fa: () => import('./fa').then((m) => m.nativeContentFa),
    fr: () => import('./fr').then((m) => m.nativeContentFr),
    hi: () => import('./hi').then((m) => m.nativeContentHi),
    it: () => import('./it').then((m) => m.nativeContentIt),
    pt: () => import('./pt').then((m) => m.nativeContentPt),
    ru: () => import('./ru').then((m) => m.nativeContentRu),
    ur: () => import('./ur').then((m) => m.nativeContentUr),
    zh: () => import('./zh').then((m) => m.nativeContentZh),
  };

export function getNativeContent(locale: string): Promise<Record<string, INativeLanguageContent>> {
  return (nativeContentLoaders[locale] ?? loadNativeEn)();
}

export type {
  INativeCognate,
  INativeLanguageContent,
  INativePitfall,
  INativeValueBlock,
} from './types';
